import {createContext, useContext} from 'react'
import PropTypes from 'prop-types'
import {useSimpleQuery} from '@frnt/base/hooks'
import {ResourceApiServiceProvider} from '../resource-api-service-provider'

const TelegramOrganizationsServiceContext = createContext(undefined)

const TelegramOrganizationsServiceProvider = ({
  children,
  baseApiHost,
  handleUnauthorized = () => {
    // Do nothing
  }
}) => {
  return (
    <ResourceApiServiceProvider
      Context={TelegramOrganizationsServiceContext}
      handleUnauthorized={handleUnauthorized}
      host={baseApiHost}
      valueCallback={(axios) => ({
        get: async (id) => {
          const {data} = await axios.get(`/api/v1/telegram/organizations/${id}`)
          return data
        },
        update: async (id, payload) => {
          const {data} = await axios.put(`/api/v1/telegram/organizations/${id}`, payload)
          return data
        }
      })}>
      {children}
    </ResourceApiServiceProvider>
  )
}

TelegramOrganizationsServiceProvider.propTypes = {
  children: PropTypes.any,
  baseApiHost: PropTypes.string.isRequired,
  handleUnauthorized: PropTypes.func
}

const useTelegramOrganizationsService = () => {
  const context = useContext(TelegramOrganizationsServiceContext)
  if (context === undefined) {
    throw new Error('TelegramOrganizationsServiceContext was not provided. Make sure your component is a child of the TelegramOrganizationsServiceProvider.')
  }
  return context
}

const useTelegramOrganizationQuery = ({id, enabled, ...otherProps}) => {
  const morningNotesService = useTelegramOrganizationsService()
  return useSimpleQuery({
    queryKey: `telegram_organizations-get-${id}`,
    queryFn: async () => morningNotesService.get(id),
    enabled: enabled !== undefined ? enabled : !!id,
    ...otherProps
  })
}

export {TelegramOrganizationsServiceProvider, useTelegramOrganizationsService, useTelegramOrganizationQuery}
